import React from 'react';
import styled from 'styled-components';
import { bellRegular } from '@amzn/storm-ui-icons';
import { Icon } from '@amzn/storm-ui';

export type BellProps = {
  showBadge: boolean;
};

const StyledWrapper = styled('span')`
  position: relative;
`;

const StyledBadge = styled(Icon)`
  color: ${({ theme }) => theme.palette.mango};
  transform: scale(0.33) translate(45px, -10px);
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
`;

const StyledBadgeRTL = styled(Icon)`
  color: ${({ theme }) => theme.palette.mango};
  transform: scale(0.33) translate(45px, -10px);
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
`;

export function Bell({ showBadge }: BellProps) {
  const dir = document.documentElement.dir;

  return (
    <StyledWrapper>
      <Icon type={bellRegular} />
      {showBadge && dir === 'rtl' && <StyledBadgeRTL type="circle" />}
      {showBadge && dir !== 'rtl' && <StyledBadge type="circle" />}
    </StyledWrapper>
  );
}
